<template>
  <div>
    <el-form label-position="top">
      <el-row>
        <el-col :span="12">
          <div class="block" style="width:270px;height:240px;">
            <el-image
              style="width: 100%; height: 100%"
              :src="imageUrl"
              :preview-src-list="[imageUrl]"
            >
              <div
                slot="error"
                class="image-slot upload-error-slot"
                style="text-align: center"
              >
                 <p class="no-data">暂无回单！</p>
              </div>
            </el-image>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item label="回单说明">
            <el-input
              placeholder="请输入回单说明"
              type="textarea"
              :rows="10"
              disabled
              v-model="podData.podRemarks"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div v-if="podData === {}" style="text-align: center">
      <img src="/image/static/img/nodata.png" />
      <p class="no-data">暂无回单！</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    code: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      podData: {},
      imageUrl: '',
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      return this.$api
        .carriageWaybillPODDetailApi({ waybillCode: this.code })
        .then((res) => {
          this.podData = res.body
          this.imageUrl = this.$osscdn(this.podData.imageUrl)
        })
    },
  },
}
</script>
